import { ActivityEvent, activityCopy } from "./activityCopy"
import { foldRunLines, TimelineDay } from "./groupTimeline"

export type ActorNames = ReadonlyMap<string, string | undefined>

const matchesSearch = (event: ActivityEvent, actorNames: ActorNames, needle: string, count = 1) => {
    const actorName = actorNames.get(event.created_by)
    const copy = activityCopy(event, { actorName, nameFor: (id) => actorNames.get(id), count })
    return `${copy} ${actorName ?? ""}`.toLowerCase().includes(needle)
}

export const filterActivityBySearch = (
    events: ActivityEvent[],
    actorNames: ActorNames,
    search: string
) => {
    const needle = search.trim().toLowerCase()
    if (!needle) return events

    return events.filter((event) => matchesSearch(event, actorNames, needle))
}

export const filterGroupedBySearch = (
    days: TimelineDay[],
    actorNames: ActorNames,
    search: string
) => {
    const needle = search.trim().toLowerCase()
    if (!needle) return days

    return days
        .map((day) => ({
            ...day,
            runs: day.runs.filter((run) =>
                foldRunLines(run.events).some((line) =>
                    matchesSearch(line.event, actorNames, needle, line.count)
                )
            ),
        }))
        .filter((day) => day.runs.length > 0)
}
